export const allUsers = state => state.users.items
export const activeUsers = state => _.filter(allUsers(state), user => !user.blocked)
export const users = state => state.users.items
export const userById = state => id => _.find(allUsers(state), {id: parseInt(id)})
export const usersByIds = state => ids => {
    return _.reduce(ids, (res, id) => {
        let user = userById(state)(id)
        if (user) res.push(user)

        return res
    }, [])
}
export const usersEmailsByIds = (state, getters) => ids => {
    let items = _.filter(getters.users, user => ids.includes(user.id))
    return _.map(items, 'email').join(', ')
}

export const userNameById = state => id => {
    let user = userById(state)(id)
    return user ? user.full_name : ''
}
export const userAvatarById = state => id => {
    let user = userById(state)(id)
    return user ? user.avatar_url : ''
}
export const currentUser = state => userById(state)(state.auth.currentUserId)
export const isCurrentUserAdmin = (state, getters) => {
    if (getters.currentUser){
        return getters.currentUser.role === 'admin'
    }
}
export const userHomeLink = state => {
    let user = currentUser(state)
    return user && user.role === 'admin' ? '/dashboard' : '/projects'
}

export const isBillingReimbVisible = state => {
    return state.users.settings.is_billing_reimb_visible
}

export const allRoles = state => state.roles.items
export const roleById = state => id => _.find(allRoles(state), {id})
